import { NavigationBehaviorOptions } from '@angular/router';
import { Component, HostListener, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { PopupMessage } from 'src/app/core/models/PopupMessage';
import { PopupMessageService } from 'src/app/core/services/popup-message.service';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  selector: 'app-popup-message',
  templateUrl: './popup-message.component.html',
  styleUrls: ['./popup-message.component.scss']
})
export class PopupMessageComponent implements OnInit, OnDestroy {
  display: boolean;
  icon: string;
  isGreyOut: boolean;
  iconImage: string;
  title: string;
  desc: string;
  btn: string;
  backgroundButton: boolean;
  onBtnClick: () => void;
  redirectLink: string;
  popupMsg$: Subscription;
  showPopupMsg$: Subscription;
  navigationSettings: NavigationBehaviorOptions;

  constructor(
    private popupMessageService: PopupMessageService,
    private navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.showPopupMsg$ = this.popupMessageService.showPopupMsg.subscribe((data: boolean) => {
      this.display = data;
    });

    this.popupMsg$ = this.popupMessageService.popupMsg.subscribe((data: PopupMessage) => {
      this.icon = data.icon ? data.icon : '';
      this.iconImage = data.iconImage ? data.iconImage : '';
      this.title = data.title;
      this.desc = data.desc;
      this.btn = data.btn;
      this.redirectLink = data.redirectLink ? data.redirectLink : '';
      this.isGreyOut = data.isGreyOut ?? false;
      this.backgroundButton = data.backgroundButton ?? false;
      this.onBtnClick = data.onBtnClick;
    });
  }

  onHide() {
    this.display = false;
    this.popupMessageService.onHide.next();

    if (this.onBtnClick) {
      this.onBtnClick();
    }

    if (this.redirectLink) {
      this.navigationService.navigateByUrl(this.redirectLink, { replaceUrl: true });
    }
  }

  ngOnDestroy() {
    this.showPopupMsg$.unsubscribe();
    this.popupMsg$.unsubscribe();
  }
}
